import PaymentService from "../../api/payments";
// import Cookies from 'js-cookie';

const state = {};

const getters = {};

const actions = {
  async getPayments({ rootState },) {
    const { authToken } = rootState.auth;
    const response = await PaymentService.getPaymentAsync(
      authToken
    );
    return response;
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
